import React from 'react';

import Form from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { Grid, Typography, Paper } from '@mui/material';
import BoweryAppraisalAccordion from './BoweryAppraisalAccordion';

import { FormOptions, wrapForm } from 'components/shared/form';

import { formOptions } from 'forms/utils/formOptions';
import { plugins } from 'forms/utils/formPlugins';
import AdjustmentsAndLossesTable from './table';

const formConfig: FormOptions = {
  fields: [
    {
      name: 'incomeApproach',
      fields: [
        {
          name: 'capRateConclusion',
          fields: [
            {
              name: 'roundingFactor',
              type: 'number',
              value: 100000,
            },

            {
              name: 'dateOfValuation',
              type: 'text',
              value: '',
            },
            {
              name: 'capRate',
              type: 'number',
              value: 0,
            },
            {
              name: 'npvAdjustments',
              type: 'array',
              value: [],
            },
            {
              name: 'asCompleteNpvAdjustments',
              type: 'array',
              value: [],
            },
            {
              name: 'asStabilizedNpvAdjustments',
              type: 'array',
              value: [],
            },
            {
              name: 'asStabilizedLossItems',
              type: 'array',
              value: [],
            },
            {
              name: 'asCompleteLossItems',
              type: 'array',
              value: [],
            },
            {
              name: 'asStabilizedResidentialRentLossItems',
              type: 'array',
              value: [],
            },
            {
              name: 'asCompleteResidentialRentLossItems',
              type: 'array',
              value: [],
            },
            {
              name: 'asStabilizedCommercialRentLossItems',
              type: 'array',
              value: [],
            },
            {
              name: 'asCompleteCommercialRentLossItems',
              type: 'array',
              value: [],
            },
            {
              name: 'asStabilizedMonthsOfRentLoss',
              type: 'number',
              value: 0,
            },
            {
              name: 'asCompleteMonthsOfRentLoss',
              type: 'number',
              value: 0,
            },
            {
              name: 'includeAsCompleteDiscountRate',
              type: 'boolean',
              value: false,
              bindings: 'Checkbox',
            },
            {
              name: 'includeAsStabilizedDiscountRate',
              type: 'boolean',
              value: false,
              bindings: 'Checkbox',
            },
            {
              name: 'asCompleteDiscountPercentage',
              type: 'number',
              value: 0,
            },
            {
              name: 'asCompleteMonthsDiscounted',
              type: 'number',
              value: 0,
            },
            {
              name: 'asStabilizedDiscountPercentage',
              type: 'number',
              value: 0,
            },
            {
              name: 'asStabilizedMonthsDiscounted',
              type: 'number',
              value: 0,
            },
          ],
        },
      ],
    },
  ],
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

type CapRateConclusionProps = {
  form: Form;
};

const CapRateConclusion = observer(({ form }: CapRateConclusionProps) => {
  return (
    <Paper elevation={0} sx={{ p: 2, mb: 6, maxWidth: '1600px' }}>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Typography variant="h6">Cap Rate Conclusion</Typography>
        </Grid>
        <Grid item xs={12}>
          <AdjustmentsAndLossesTable form={form} />
        </Grid>
      </Grid>
      <BoweryAppraisalAccordion />
    </Paper>
  );
});

export default wrapForm({
  ...formConfig,
})(CapRateConclusion);
